import { Schedule, ClassroomScheduleTableData } from "../../../types/Classrooms";
import { ClassroomScheduleEntry } from "../../../utils/api/classroomSchedules";

export function formatSchedules(schedules: ClassroomScheduleEntry[]): ClassroomScheduleTableData {
  let hasData = false;

  const schedule: Schedule = {
    mon: [],
    tue: [],
    wed: [],
    thur: [],
    fri: [],
    sat: [],
    sun: [],
  };

  const dayMapping: { [key: string]: keyof Schedule } = {
    MONDAY: "mon",
    TUESDAY: "tue",
    WEDNESDAY: "wed",
    THURSDAY: "thur",
    FRIDAY: "fri",
    SATURDAY: "sat",
    SUNDAY: "sun",
  };

  schedules.forEach((entry) => {
    const dayRef = dayMapping[entry.day];
    if (dayRef && !entry.paused) {
      schedule[dayRef].push(`${entry.startTime} - ${entry.endTime}`);
      hasData = true;
    }
  });

  return hasData ? [schedule] : [];
}
